import {lazy} from 'react';

import {
  type RunsDataQuery,
  toRunsDataQuery,
} from '../../containers/RunsDataLoader';
import type {PanelSpec} from '../../util/panelTypes';
import type {Query} from '../../util/queryTypes';
import {WEAVE_TRACE_PANEL_TYPE, WeaveTraceConfig} from './common';

const transformQuery = (query: Query): RunsDataQuery => {
  const result = toRunsDataQuery(query, undefined, {panelType: 'Weave Trace'});
  result.disabled = true;
  return result;
};

const configSpec = {};

export const Spec: PanelSpec<typeof WEAVE_TRACE_PANEL_TYPE, WeaveTraceConfig> =
  {
    type: WEAVE_TRACE_PANEL_TYPE,
    Component: lazy(() => import('./Component')),
    transformQuery,
    configSpec,
    noEditMode: true,
    icon: 'panel-table',
  };
